var map = {
	"./cn.json": "f0f4",
	"./cn_tw.json": "83d3",
	"./de.json": "2508",
	"./en.json": "e088",
	"./es.json": "d90a",
	"./fr.json": "2394",
	"./it.json": "06b7",
	"./ja.json": "19d0",
	"./ru.json": "626a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d950";